import React from 'react'
import moment from 'moment'

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ReferenceLine,
} from 'recharts'

import { parseAsNumber } from '../../../../utils/parse'

const CustomTooltip = ({ active, payload, label, events }) =>
    active &&
    payload && (
        <div className="custom-tooltip">
            <h4>{parseAsNumber(label) * -1} day(s) till event</h4>
            {payload.map(tagValue => {
                const event = events[tagValue.name]
                const date = moment(event.date)
                    .add(label, 'days')
                    .format('ddd Do MMM YYYY')

                return (
                    <div key={tagValue.name}>
                        <span
                            className="m-r-sm"
                            style={{
                                display: 'inline-block',
                            }}
                        >
                            <strong>{tagValue.value}</strong>
                        </span>
                        <span
                            style={{
                                color: tagValue.stroke,
                            }}
                        >
                            <strong>
                                {event.name} | {date}
                            </strong>
                        </span>
                    </div>
                )
            })}
        </div>
    )

const SalesChart = ({
    events,
    sales,
    palette,
    isMoreThanOneEventInTheFuture,
}) => {
    const eventDescriptionIndexedByEventId = events.reduce(
        (acc, event) => ({
            ...acc,
            [event.eventId]: {
                name: event.eventName,
                date: event.eventDateInVenueTimezone,
            },
        }),
        {},
    )

    return (
        <ResponsiveContainer width="100%" height={250}>
            <LineChart
                data={sales}
                margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    padding={{ left: 20, right: 20 }}
                    dataKey="DaysToEvent"
                    tickFormatter={x => -1 * x}
                />
                <YAxis />
                <Legend
                    payload={[
                        {
                            value: 'Days until event',
                            type: 'line',
                        },
                    ]}
                />
                <Tooltip
                    content={
                        <CustomTooltip
                            events={eventDescriptionIndexedByEventId}
                        />
                    }
                />
                {events.map((event, index) => (
                    <Line
                        dot={false}
                        key={event.eventId}
                        type="monotone"
                        dataKey={event.eventId}
                        stroke={palette[index]}
                        strokeWidth={2}
                    />
                ))}
                {!isMoreThanOneEventInTheFuture &&
                    events.map((event, index) => (
                        <ReferenceLine
                            key={event.eventId}
                            x={event.daysTillEvent}
                            stroke={palette[index]}
                            label="Today"
                            strokeWidth={2}
                        />
                    ))}
            </LineChart>
        </ResponsiveContainer>
    )
}
export default SalesChart
